export default "__VITE_ASSET__Brok_n1b__"